import React, {useEffect, useRef,useState } from "react"; 
import { Button, Modal } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import {getBannerDetails} from "../../../../Services/marketingBannersServices"
import {getEnvUrl} from "../../../../utils/Api"
const ViewBanner = ({bannerId,isShow,close }) => {  
  const handleShow = () => setShow(true);
  const handleClose = () => {setShow(false);close()};
  const [show, setShow] = useState(false);
  const [bannerData, setBannerData] = useState(false);
  useEffect(() => { 
    getBannerDetails(bannerId).then((data)=>{
      console.log(data.data)
      if(data.status){
        setBannerData(data.data)
      } 
    })
    setShow(isShow)
  }, []); 
  return ( 
    <Modal show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <h5 className="modal-title">Banner</h5>
        </Modal.Header>
        <Modal.Body>
        <form className="row g-3" id="bannerform"  method="post" enctype="multipart/form-data">
            <div className="col-12 px-3">
              <label for="viewGameSubject" className="form-label">Subject : {bannerData?.game?.gamelevel?.gamesubject?.subject_name}</label>
               <span id="viewGameSubject"></span>
            </div>
            <div className="col-12 px-3">
              <label for="viewGameBannerCategory" className="form-label">Category : {bannerData?.game?.gamelevel?.level_name}</label>
              <span id="viewGameBannerCategory"></span>
            </div>
            <div className="col-12 px-3">
              <label for="viewGameName" className="form-label">Game Name : {bannerData?.game?.game_name}</label>
              <span id="viewGameName"></span>
            </div>
            <div className="col-12 px-3">
              <label for="viewBannerDescription" className="form-label">Description : {bannerData?.description}</label>
              <span id="viewBannerDescription"></span>               
            </div>
            <div className="col-12 px-3">
              <label for="viewBannerCampaignType" className="form-label">Campaign Type : {bannerData?.campaign_type} </label>
              <span id="viewBannerCampaignType"></span>               
            </div>   
            <div className="col-12 px-3">
              <label for="viewBannerImage" className="form-label">Banner Image : </label>
              <div id="viewBannerImage">
                <img src={`${getEnvUrl()}/game/getBannerimg?type=${bannerData?.campaign_type}&id=${btoa(btoa(bannerData?.id))}&hash=${Date.now()}`} width='300' alt='Banner Image' /></div>              
            </div>
          </form>
        </Modal.Body>
        <Modal.Footer>
            
        </Modal.Footer>
      </Modal>
       
  );
};

export default ViewBanner;

